// API para la calculadora de costos de confección

import { dotoniwoofApi } from '../api/dotoniwooApi';

const apiResult = (response) => ({
  ok: true,
  status: response.status,
  data: response.data,
});

const apiError = (error) => ({
  ok: false,
  status: error.response?.status || 500,
  data: error.response?.data || { message: 'Error de conexión' },
});

export const getSizeSpecs = async (sizeCode = null) => {
  try {
    const params = sizeCode ? { size_code: sizeCode } : {};
    const response = await dotoniwoofApi.get('/sizeSpec.php', { params });
    return apiResult(response);
  } catch (error) {
    console.error('Error al obtener tallas:', error);
    return apiError(error);
  }
};

export const getGarmentTypes = async () => {
  try {
    const response = await dotoniwoofApi.get('/garmentType.php');
    return apiResult(response);
  } catch (error) {
    console.error('Error al obtener tipos de prenda:', error);
    return apiError(error);
  }
};

export const calculateCost = async (payload) => {
  try {
    const response = await dotoniwoofApi.post('/costCalculator.php', payload);
    return apiResult(response);
  } catch (error) {
    console.error('Error al calcular costo:', error);
    return apiError(error);
  }
};
